export default __webpack_public_path__ + "static/media/img1.2655a2a0.jpg";